import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './OfferedPriceCustomer.module.scss';
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";

// Promo codes were intentionally REMOVED from order creation: a promo must
// discount the PAYMENT amount (at offer acceptance / mono), not the price
// cleaners bid against. The Promotion model, admin CRUD and the public
// /promotions/ "Акції" list stay; the input will be re-added on the payment
// step when mono is wired. This component now only collects the request price.
const OfferedPriceCustomer = ({minPrice}) => {
  const dispatch = useDispatch();
  const {request_price: price} = useSelector(state => state.stepperInfo);

  const handleInputChange = (e) => {
    // clear error if it exists
    const requestPriceLabel = document.getElementById("request_price");

    if (requestPriceLabel) {
      const inputElement = requestPriceLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = requestPriceLabel.querySelector("span");
      if (errorMessageSpan) {
        requestPriceLabel?.removeChild(errorMessageSpan);
      }
    }

    const price = e.target.value;
    const regex = /^\d+$/;
    if (regex.test(price)) {
      dispatch(stepperInfoActions.setRequestPrice(price));
    } else {
      dispatch(stepperInfoActions.setRequestPrice(""));
    }
  }

  return (
    <div className={styles.offeredPriceCustomer}>
      <div className={styles.offeredPriceCustomer_titlesContainer}>
        <p>Вартість послуги</p>
        <p>*Мінімальна ціна {minPrice} грн</p>
      </div>

      <form
        className={styles.offeredPriceCustomer_form}
        action="#"
      >
        <label id={"request_price"} className={styles.offeredPriceCustomer_form_error}>
          <input
            defaultValue={price || null}
            className={styles.input}
            placeholder={'Введіть вартість'}
            type={'text'}
            onChange={handleInputChange}
          />
        </label>
      </form>
    </div>
  );
};

export default OfferedPriceCustomer;
